"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgAddDates(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "4 -4 16 24" }, props),
        React.createElement("path", { d: "M12.084 0C16.59 0 20 3.582 20 8s-3.494 8-8 8c-3.72 0-6.706-2.441-7.688-5.78-.01-.034 1.635-.907 1.82-1.04l.017-.017C6.7 11.92 9.026 14 12 14c3.38 0 6-2.686 6-6s-2.62-6-6-6c-1.779-.006-3.32.758-4.493 2.095l1.57.937L4 8V2l1.603.961.55-.598c.04-.043.07-.074.083-.086C7.79.81 9.779-.005 11.916 0zm.166 4v4.535l3.009 1.93-.865 1.292-3.644-2.48V4h1.5z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('AddDates')(SvgAddDates);
//# sourceMappingURL=AddDates.js.map